import { useGetFeaturesFlags } from "@/hooks/useGetFeaturesFlags/useGetFeaturesFlags";

/**
 * Predicted CSAT is gated behind a dedicated feature flag. The asset page only
 * surfaces the CSAT section when the flag is enabled for the company.
 */
export function useHasPredictedCsat(): boolean {
  const featureFlags = useGetFeaturesFlags();

  return Boolean(featureFlags?.dashboardExtensionEnableConversationsCenterCsat);
}
